import React , { useEffect }from 'react';
import InterestInventory from "./InterestInventory";
import ConfirmationDialog from "./ConfirmationDialog";
import YoutubeEmbed from "./YoutubeEmbed";
import ResultPage from "./ResultPage";
import ChatBot from "./ChatBot";
import { useState } from "react";
import { useStateValue } from "../state";
import domtoimage from "dom-to-image";
import '../css/InterestInventory.scss';
import { 
  codeExplanation,
  codeExplanationBg,
  videoSrc,videoSrcbg,
  videoSrcHn,codeExplanationHn

}from "../constants/inventoryConstants";
import {
  fetchCoursesByHollandCode,
} from "./../actions/courseActions";
import {
    domtoImage,
} from "./../actions/documentActions";
import Text from "@material-ui/core/FormHelperText";
import RowChart from "./RowChart";
import { resetState } from "../actions/homeAction";
import {hideConfirm, showConfirm, showResult, showChatbot} from "../actions/confirmAction";
import { useTranslation } from 'react-i18next';

const GameTransition = () => {
  const [{ studentDetails }] = useStateValue();
  const [{ inventoryDetails }] = useStateValue();
  const [{ documentDetails }] = useStateValue();
  const [{ courseDetails }] = useStateValue();
  const [{ dialog }] = useStateValue();
  const [{ jwtToken }, dispatch] = useStateValue();
  const [renderView, setrenderView] = useState(false);
  const [bitChart, setBitChart] = useState();
  const [url, setUrl] = useState("");
  const { t, i18n } = useTranslation();
  const lng = i18n.language || window.localStorage.getItem("lng");

  const handleClick = (event) => {
    event.preventDefault();
    showConfirm(dispatch);
  }

const onDismiss = () => {
  hideConfirm(dispatch);
}
const onConfirm = () => {
  hideConfirm(dispatch);
  setrenderView(true);
  }

const onResultsDismiss = () => {
  hideConfirm(dispatch);
}
const onResultsConfirm = () => {
  hideConfirm(dispatch);
  setrenderView(false);
  showResult(dispatch);
}

// Added language condition to accomodate the language specif videos

useEffect(() => {
  if(lng === "bg"){
  const src = (videoSrcbg.filter((video) => video.letter === (inventoryDetails?.inventory?.finalScore[0])).map(filteredVideo => filteredVideo.source))[0];
  setUrl('https://www.youtube.com/embed/'+src+'?playlist='+src+'&loop=1');
  }

  else if(lng === "hn"){
    const src = (videoSrcHn.filter((video) => video.letter === (inventoryDetails?.inventory?.finalScore[0])).map(filteredVideo => filteredVideo.source))[0];
    setUrl('https://www.youtube.com/embed/'+src+'?playlist='+src+'&loop=1');
    }

    else if(lng === "tl"){
      const src = (videoSrc.filter((video) => video.letter === (inventoryDetails?.inventory?.finalScore[0])).map(filteredVideo => filteredVideo.source))[0];
      setUrl('https://www.youtube.com/embed/'+src+'?playlist='+src+'&loop=1');
      }
  else{
    const src = (videoSrc.filter((video) => video.letter === (inventoryDetails?.inventory?.finalScore[0])).map(filteredVideo => filteredVideo.source))[0];
    setUrl('https://www.youtube.com/embed/'+src+'?playlist='+src+'&loop=1');
    }
},[inventoryDetails?.inventory?.finalScore]); 

useEffect(() => {
  if(inventoryDetails?.inventory?.hollandCodeReverificationCode?.length > 0){
      getCourseDataAndSaveInterestInventoryDocument();
  }
},[inventoryDetails?.inventory?.hollandCodeReverificationCode]); 


const getCourseDataAndSaveInterestInventoryDocument = () => {
  fetchCoursesByHollandCode(dispatch, inventoryDetails?.result, jwtToken);
};

const getCodeText = (hollandCode) => {
  if(lng === "bg"){
    const letters = hollandCode.split('');
    const codeText = [];
    letters.map(letter => (
      codeText.push(codeExplanationBg.filter((l) => l.letter === letter))
    ));
    return codeText;
  }

  else if(lng === "hn"){
    const letters = hollandCode.split('');
    const codeText = [];
    letters.map(letter => (
      codeText.push(codeExplanationHn.filter((l) => l.letter === letter))
    ));
    return codeText;
  }
  else if(lng === "tl"){
    const letters = hollandCode.split('');
    const codeText = [];
    letters.map(letter => (
      codeText.push(codeExplanation.filter((l) => l.letter === letter))
    ));
    return codeText;
  }
  else {
    const letters = hollandCode.split('');
    const codeText = [];
    letters.map(letter => (
      codeText.push(codeExplanation.filter((l) => l.letter === letter))
    ));
    return codeText;
  }
  
};

 /* save interest inventory document before moving to next page */
 const handleResultPage = (event) => {
  event.preventDefault();
  if(documentDetails?.basicDocId === null || documentDetails?.basicDocId === undefined) {
    domtoimage.toPng(document.getElementById('chart'))
    .then((dataUrl) => {
    domtoImage(dispatch,studentDetails?.student?.dbUserId, studentDetails?.student?.engagementId, courseDetails?.courses, dataUrl, studentDetails?.student?.firstName, inventoryDetails?.inventory?.finalScore, jwtToken, lng);
    });
  }

  showConfirm(dispatch);
}

return (
  <div>  
    <div>
      {/* Game results doesnts exists - and video wath conformation not done- Then show youtube video */}
      {/* user chose to replay game, then return to page showing youtube video */}
      {( (!renderView && (inventoryDetails?.inventory?.finalScore === undefined || inventoryDetails?.inventory?.finalScore.length === 0)) || (!renderView && dialog.enableReplay === true && !dialog.showResult) ) && (
      <form className= "game-form" onSubmit={handleClick}>
      <div  class="game_body">
        <div className = "game_body_30">
        <div className = "game-bold-text"> {t('beforeNameHappyText')} {studentDetails?.student?.firstName.toUpperCase()} {t('afterNameHappyText')}!</div>     
          <div className = "game-text-reduced">{t('knowHowToPlayGame')} </div>
        </div>
        <div className = "game_body_70"> 
          <div class="game_video"><center><YoutubeEmbed embedId={t('gameVideo')} /></center></div>
        </div>
      </div> 
      <div class="game_button">
          <button type ="submit" className="submit">{t('letsPlayGame')}</button>
          {dialog.confirm && <ConfirmationDialog open = {true} title = {t('gamevideoConfirmation')} onConfirm = {onConfirm} onDismiss = {onDismiss}></ConfirmationDialog>}
      </div>
      
      </form>
    )}
    </div>

    {/* Game results doesnts exists - and video watched- Then show game */}
    <div>
      { ((renderView && (inventoryDetails?.inventory?.finalScore === undefined || inventoryDetails?.inventory?.finalScore.length === 0)) || (renderView && dialog.enableReplay !== undefined)) && (
        <InterestInventory /> 
      )}
    </div>

    {/*Game allredy played  - Chat bot is not yet verified*/}
    <div>
      { ( inventoryDetails?.inventory?.finalScore !== undefined  && inventoryDetails?.inventory?.finalScore ?.length > 0 && (inventoryDetails?.inventory?.hollandCodeReverificationCode === undefined || inventoryDetails?.inventory?.hollandCodeReverificationCode.length === 0))  && (
          <ChatBot />
      )} 
    </div>



    {/* Both Game and Bot validation done- Then show results */}
    
    { (inventoryDetails?.inventory?.hollandCodeReverificationCode?.length > 0 && !dialog?.showResult) && (
      <div  className="container-padding" id="resultDiv">
        
        <div class = "results-bold-text"> {t('congratulations')} {studentDetails?.student?.firstName}! {t('lookAtResults')}  </div>
        <div class = "results-text-reduced"> {t('AfterGameMsg')} <span class="results-bold-text"> {inventoryDetails?.inventory?.finalScore} </span> </div>
        
        <div class="image_results_table" >
          <div  class="image_results_70 ">
          <table >
            {getCodeText(inventoryDetails?.inventory?.finalScore).map((item) => (
                <tr className= "inv-tr">
                  <td key = {item[0].letter}><Text class="results-text-reduced"> {item[0].letter} </Text></td> 
                  <td><Text class="results-text-reduced"> {":"}</Text></td>
                  <td key = {item[0].text}> <Text class="results-text-reduced">{item[0].text}</Text></td>
                </tr>
              ))}
          </table>
          </div> 
          <div   id="chart" >
            <RowChart data={inventoryDetails?.inventory?.gameResults} />
          </div>
        </div>

        


        <div className="alert_text-reduced row_center"> {t('watchCareerVideo')} </div>
          
          <div className="row_center">
            <iframe
              src= {url}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title="YouTube video player"
              width="90%"
              height="200px"
            /> 
          </div> 
        
        

        <div class = "results-text-reduced row_center"> <button type="submit" className = "submit-blue" onClick= {handleResultPage} >{t('clickHereButton')}</button> {t('knowMoreAboutMatchingCareers')} </div>            
        <div>
          {dialog.confirm && <ConfirmationDialog open = {true} title = {t('careervideoConfirmation')} onConfirm = {onResultsConfirm} onDismiss = {onResultsDismiss}></ConfirmationDialog>}
        </div> 
      </div>           
      
      )}
    

    { (dialog?.showResult  && documentDetails?.basicDocId > 0 && inventoryDetails?.inventory?.finalScore.length > 0 && inventoryDetails?.inventory?.hollandCodeReverificationCode?.length > 0)  && (
      <div>
        <ResultPage/>
      </div>  
    )}

    { dialog?.showResult  && (documentDetails?.basicDocId === null || documentDetails?.basicDocId === undefined) && (
      <div>
        <div className = "game-bold-text">
          {t('internetError')}
        </div>
      </div>  
    )}

  </div>
  );
}

export default GameTransition;
